function customOfferTag(arrOfProds, groups){
    if(groups){
        arrOfProds.forEach(prod => {
            prod.produtos.forEach(elm => {
                if(elm.precos.preco_promocao !== 0) {
                    const prod = document.querySelectorAll(`[ws-prod-sku="${elm.codigo}"]`)
                    prod.forEach(allProd => {
                        allProd.querySelector('.offerTag').classList.add('hasOffer')
                    })
                }
            })
        });
    } else {
        arrOfProds.forEach(prod => {
            if(prod.precos.preco_promocao !== 0){
                console.log(prod.codigo, prod.precos.preco_promocao)
                const container = document.querySelectorAll(`[ws-prod-sku="${prod.codigo}"]`)
                container.forEach(allProd => {
                    allProd.querySelector('.offerTag').classList.add('hasOffer')
                })
            }
        });
    }
}

function customOfferCall(){
    try {
        wsMain.globalData.listGroupProds? customOfferTag(wsMain.globalData.listGroupProds.grupos, true) : ""
        wsMain.globalData.listCategoryProds? customOfferTag(wsMain.globalData.listCategoryProds.produtos) : ""
        wsMain.globalData.listHomeProds? customOfferTag(wsMain.globalData.listHomeProds.produtos) : ""
    } catch (error) {
        console.log(error)
    }
    console.log('akira')
}

try {
    isReady("product-list", customOfferCall)
} catch (error) {
    console.log(error)
}